import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from '../guards/auth.guard';
import { CyberTripsComponent } from './cyber-trips.component';

const routes: Routes = [
  { path: '', component: CyberTripsComponent, canActivate: [AuthGuard] }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CyberTripsRoutingModule {}
